module.exports = __webpack_public_path__ + "static/media/activity-no-results.5e7e42ed.svg";